import { Component } from '@angular/core';
import { Platform, App } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { HomePage } from '../pages/home/home';
import { AngularFireAuth } from 'angularfire2/auth';
import { RoulettePage } from '../pages/roulette/roulette';

@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  rootPage: any = HomePage;

  constructor(platform: Platform, private app: App, statusBar: StatusBar, private aFAuth: AngularFireAuth, splashScreen: SplashScreen, private auth: AngularFireAuth) {
    const unsubscribe = aFAuth.auth.onAuthStateChanged(user => {
      if (!user) {
        this.rootPage = HomePage;
        this.app.getActiveNav().setRoot(HomePage);
      } else {
        this.rootPage = RoulettePage;
        this.app.getActiveNav().setRoot(RoulettePage);
      }
    });

    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts